import type { SlotPlacement } from '@hen-site/app/hooks/useMonarchSlotData';
import type { PersonalizedAssetType } from '@hen-site/types/monarch';

export type MonarchSlotFlowData = {
  flowId?: string;
  // Monarch personalization asset for this slot, mapped to the `slotVariant`
  // dimension (`'default'` when absent).
  PersonalizedAssetType?: PersonalizedAssetType;
};

function trimNonemptyFlowId(raw?: string): string | undefined {
  const trimmed = raw?.trim();
  return trimmed ? trimmed : undefined;
}

/**
 * Resolves the flow ID passed to Dynamic Experience.
 * CMS override wins; otherwise use Monarch traffic-flow slot data when loaded.
 */
export function resolveEffectiveForcedFlowId(
  explicitFlowId: string | undefined,
  monarchSlot: SlotPlacement<MonarchSlotFlowData>,
  isMonarchLoading: boolean,
): string | undefined {
  const fromExplicit = trimNonemptyFlowId(explicitFlowId);
  if (fromExplicit) {
    return fromExplicit;
  }

  if (isMonarchLoading) {
    return undefined;
  }

  return trimNonemptyFlowId(monarchSlot.value?.flowId);
}
